import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ThunkGetTableData } from 'store/table/thunks';
import { RootState } from '../index';

interface I {
  id: number;
}

const initialState: { rows: I[]; totalCount: number } = {
  rows: [],
  totalCount: 0,
};

const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    addOnTop: (state, action) => {
      if (state.rows?.find(i => i.id === action.payload.id)) {
        state.rows = state.rows.map(i => (i.id === action.payload.id ? action.payload : i));
      } else {
        state.rows.unshift(action.payload);
      }
    },
    updateItem: (state, action) => {
      state.rows = state.rows.map(i => (i.id === action.payload.id ? action.payload : i));
    },
    addToList: (state, action) => {
      state.rows = [...state.rows, ...action.payload];
    },
    clearList: state => {
      state.rows = [];
    },
    removeItemFromList: (state, actions) => {
      state.rows = state.rows.filter(i => i.id !== actions.payload);
      state.totalCount--;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      ThunkGetTableData.fulfilled,
      (state, action: PayloadAction<{ data: I[]; start: number; totalCount: number }>) => {
        state.rows = action.payload.data;

        state.totalCount = action.payload.totalCount;
      },
    );
  },
});

export default tableSlice.reducer;
export const DataSelector = (state: RootState): any[] => state.table.rows;
export const TotalCountSelector = (state: RootState): number => state.table.totalCount;
export const { addOnTop, updateItem, addToList, clearList, removeItemFromList } = tableSlice.actions;
